module.exports = __webpack_public_path__ + "static/media/Logo 8.bbc0f0ee.png";